import type { FlightSearchCriteria } from "@/features/flights/types/types";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { getCityName } from "@/utils/locations";

export function buildFlightSearchCriteria(
  searchData: FlightSearchFormValues,
): FlightSearchCriteria {
  return {
    tripType: searchData.tripType,
    departure_city: getCityName(searchData.from) || undefined,
    destination: getCityName(searchData.to) || undefined,
    travel_date: searchData.dates.departure,
    return_date: searchData.dates.return,
    travellers: searchData.adult + searchData.child,
  };
}
